import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Page from 'components/Page';
import ScrollToTopButton from 'components/ScrollToTop';
import { getRoute } from '@common/constants/CampusRoutes';
import store from 'store';

import useModel from '@common/helpers/useModel';
import NewsItem, { INewsItemModel } from '@common/models/News/NewsItem';

import NewsItemPageSection from './NewsItemPageSection';

function NewsItemPage() {
	const { id } = useParams();
	const newsItem = useModel(NewsItem, { id: +id }, [id]) as INewsItemModel;

	const navigate = useNavigate();
	const handleGoBack = () => {
		navigate(getRoute(['NEWS']));
	};

	useEffect(() => {
		if (newsItem.id) {
			store.markNewsAsVisited(newsItem.id);
		}
	}, [newsItem.id]);

	return (
		<>
			<Page
				type="content"
				onGoBack={handleGoBack}
				title={newsItem.title}
				isLoading={newsItem.loading}
			>
				<NewsItemPageSection newsItem={newsItem} />
			</Page>
			<ScrollToTopButton />
		</>
	);
}

export default observer(NewsItemPage);
